
import { NavLink, useNavigate } from 'react-router-dom';
import CardHighlight from '../cardHighlight';

import '../../App.scss';

import json2019 from '../../data/2019-filenames.json';
import json2020 from '../../data/2020-filenames.json';
import json2021 from '../../data/2021-filenames.json';
import json2022 from '../../data/2022-filenames.json';
import jsonaapi from '../../data/aapi-filenames.json';


export default function reviewHighlight(props) {

		var titles = new Set(); //all the unique 2019 titles

		var titlesList = jsonaapi["movies"]
		.concat(jsonaapi["tv"])
		.concat(json2022["movies"])
		.concat(json2022["tv"])
		.concat(json2021["movies"])
		.concat(json2021["tv"])
		.concat(json2020["movies"])
		.concat(json2020["tv"])
		.concat(json2019["movies"])
		.concat(json2019["tv"]);

		for (let i = 0; i < titlesList.length; i++) {
			let t = titlesList[i]
			titles.add(t);
		}
	
		var allCardData = []
		titles.forEach(function(title) {
			if (props.titles.includes(title)) {
				allCardData.push({"title": title, })
			}
		})

	    return (
			<div className='white'>
				<div className="align-left section-header view-all">
					<h1>{props.sectionName}</h1>
				</div>
				<div className='align-left collection'>
					{allCardData.map((item => (
						<CardHighlight
							title={item["title"]}
						/>
						)))}
				</div>

			</div>
	    );
	}